import type { ReactNode } from 'react';

import { cn } from '../lib/cn';

interface IOptionCardProps {
  selected?: boolean;
  control: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
  as?: 'label' | 'div';
  className?: string;
}

export const OptionCard = ({
  selected,
  control,
  title,
  description,
  children,
  as = 'div',
  className,
}: IOptionCardProps) => {
  const Tag = as;

  return (
    <div
      className={cn(
        'rounded-option px-flat-lg py-3',
        selected ? 'bg-option-selected' : 'bg-field-muted',
        className,
      )}
    >
      {/* `children` stays outside the label: inside it, a click on a revealed field would also toggle the choice. */}
      <Tag className={cn('flex items-start gap-inset', as === 'label' && 'cursor-pointer')}>
        <span className="flex shrink-0 items-center pt-tight">{control}</span>
        <span className="min-w-0 flex-1">
          <span className="block text-data font-medium text-primary">{title}</span>
          {description && (
            <span className="mt-tight block text-meta leading-17 text-muted">{description}</span>
          )}
        </span>
      </Tag>
      {children && <div className="mt-3">{children}</div>}
    </div>
  );
};
